







// Import vendors ----------------------------------------------------------------------------------
import { defineComponent } from '@vue/composition-api';
// Import components -------------------------------------------------------------------------------
import PatientResultsScoringSQI from '@/components/patient/results/PatientResultsScoringSQI.vue';
import PatientResultsScoringGVI from '@/components/patient/results/PatientResultsScoringGVI.vue';
// -------------------------------------------------------------------------------------------------

export default defineComponent({
  name: 'PatientResultsScoring',
  components: {
    PatientResultsScoringSQI,
    PatientResultsScoringGVI
  },
  props: {
    analysis: {
      type: Object,
      required: true
    },
    showParameters: {
      type: Boolean,
      default: true
    }
  }
});
